import axios from "axios";
import { Payout_Service } from "../Url";

export const PayoutQueryInternalAction = {
    RAISE_PAYOUT_QUERY_INTERNAL_SUCCESS: "RAISE_PAYOUT_QUERY_INTERNAL_SUCCESS",
    RAISE_PAYOUT_QUERY_INTERNAL_FAILURE: "RAISE_PAYOUT_QUERY_INTERNAL_FAILURE",
    RESOLVE_PAYOUT_QUERY_INTERNAL_SUCCESS: "RESOLVE_PAYOUT_QUERY_INTERNAL_SUCCESS",
    RESOLVE_PAYOUT_QUERY_INTERNAL_FAILURE: "RESOLVE_PAYOUT_QUERY_INTERNAL_FAILURE",

};


export function getRaisePayoutQueryInternalAction(props) {
    const { accessToken, query } = props;
    return async (dispatch) => {
        try {
            const response = await axios({
                method: "post",
                headers: {
                    authorization: "Bearer " + accessToken,
                    "Access-Control-Allow-Origin": "*",
                },
                url: `${Payout_Service}/reports/raisePartnerQuery`,
                // url: `http://localhost:8301/partner-payout-service/reports/raisePartnerQuery`,
                data:query,
            });
            const data = response.data;
            console.log("Raise Payout Query Internal Data:", data);
            // dispatch({
            //     type: PayoutQueryInternalAction.RAISE_PAYOUT_QUERY_INTERNAL_SUCCESS,
            //     payload: data.data,
            // });
            return data.data;
        } catch (error) {
            console.error("Error:", error);
            // dispatch({
            //     type: PayoutQueryInternalAction.RAISE_PAYOUT_QUERY_INTERNAL_FAILURE,
            //     payload: error.message || "Failed to fetch payout query internal data",
            // });
            return error;
        }
    };
}

export function getPayoutQueryInternalActionv2(props) {
    const { accessToken, query } = props;
    return async (dispatch) => {
        try {
            const response = await axios({
                method: "post",
                headers: {
                    authorization: "Bearer " + accessToken,
                    "Access-Control-Allow-Origin": "*",
                },
                url: `${Payout_Service}/reports/raisePartnerQuery-v2`,
                data:query
            });
            const data = response.data;
            console.log("Get Payout Query Internal Data:", data.data);
          
            return data.data;
        } catch (error) {
            console.error("Error:", error);
           
            return error;
        }
    };
}




export function getResolvePayoutQueryInternalAction(props) {
    const { accessToken, query} = props;
    return async (dispatch) => {
        try {
            const response = await axios({
                method: "post",
                headers: {
                    authorization: "Bearer " + accessToken,
                    "Access-Control-Allow-Origin": "*",
                },
                url: `${Payout_Service}/reports/partnerQueryResolved`,
                // url: `http://localhost:8301/partner-payout-service/reports/partnerQueryResolved`,
                data:query
            });
            const data = response.data;
            console.log("Resolve Payout Query Internal Data:", data.data);
            // dispatch({
            //     type: PayoutQueryInternalAction.RESOLVE_PAYOUT_QUERY_INTERNAL_SUCCESS,
            //     payload: data.data,
            // });
            return data.data;
        } catch (error) {
            console.error("Error:", error);
            // dispatch({
            //     type: PayoutQueryInternalAction.RESOLVE_PAYOUT_QUERY_INTERNAL_FAILURE,
            //     payload: error.message || "Failed to fetch payout query internal data",
            // });
            return error;
        }
    };
}

